const cookieSecure = process.env.VUE_APP_COOKIE_SECURE == "true" ? true : null;
const cookieDomain = process.env.VUE_APP_COOKIE_DOMAIN;

import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

Vue.use(Vuex);
import createPersistedState from "vuex-persistedstate";

import moduleAuth from "./auth/moduleAuth.js";
import moduleRentcar from "./rentcar/moduleRentcar.js";
import moduleCampus from "./campus/moduleCampus.js";
import moduleBanks from "./banks/moduleBanks.js";

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    auth: moduleAuth,
    rent: moduleRentcar,
    campus: moduleCampus,
    banks: moduleBanks
  },
  strict: process.env.NODE_ENV !== "production",
  plugins: [
    createPersistedState()
    // createPersistedState({
    //   key: process.env.VUE_APP_VUEX_KEY,
    //   paths: [
    //     "bodyOverlay",
    //     "theme",
    //     "sidebarWidth",
    //     "sidebarItemsMin",
    //     "reduceButton"
    //   ],
    //   getState: key => $cookies.get(key),
    //   setState: (key, state) =>
    //     $cookies.set(key, state, null, null, cookieDomain, cookieSecure)
    // })
  ]
});
